import {
  ANALYST_GROUPS,
  RISK_LEVEL,
  VERIFICATION_RESULT,
} from '@/constants/analyst-constants';
import { severityLevelToDescription } from '@/constants/signalNames';
export const RISKS_CONFIG = {};
RISKS_CONFIG[VERIFICATION_RESULT.LOW_RISK] = {
  label: 'Low Risk',
  tooltipInfo:
    'Verifications considered low risk, where the provided information matches the verified data.',
};
RISKS_CONFIG[VERIFICATION_RESULT.HIGH_RISK] = {
  label: 'High Risk',
  tooltipInfo:
    'Verifications indicating significant discrepancies between the provided information and the verified data.',
};
RISKS_CONFIG[VERIFICATION_RESULT.INCONCLUSIVE] = {
  label: 'Inconclusive',
  tooltipInfo:
    'Verifications that were inconclusive, requiring further investigation or additional data to confirm.',
};
RISKS_CONFIG[RISK_LEVEL.LOW] = {
  label: 'Low Risk',
  tooltipInfo: severityLevelToDescription(RISK_LEVEL.LOW),
};
RISKS_CONFIG[RISK_LEVEL.MEDIUM] = {
  label: 'Medium Risk',
  tooltipInfo: severityLevelToDescription(RISK_LEVEL.MEDIUM),
};
RISKS_CONFIG[RISK_LEVEL.MEDIUM_RISK] = {
  label: 'Medium Risk',
  tooltipInfo: severityLevelToDescription(RISK_LEVEL.MEDIUM),
};
RISKS_CONFIG[RISK_LEVEL.HIGH] = {
  label: 'High Risk',
  tooltipInfo: severityLevelToDescription(RISK_LEVEL.HIGH),
};
RISKS_CONFIG[RISK_LEVEL.NOT_APPLICABLE] = {
  label: 'Not Applicable',
  tooltipInfo: 'Not Applicable',
};
RISKS_CONFIG[RISK_LEVEL.TRUST] = {
  label: 'Trust',
  tooltipInfo: 'Trust Signal',
};
RISKS_CONFIG.Failed = {
  label: 'Failed',
};
RISKS_CONFIG.Passed = {
  label: 'Passed',
};

export const ANALYST_GROUPS_CONFIG = {};
ANALYST_GROUPS_CONFIG[ANALYST_GROUPS.RISKS] = {
  label: 'Verifications',
  tooltipInfo:
    'Displays the results of AI Fraud Analyst verifications, grouped by risk level',
  linkUrl: 'https://help.inscribe.ai/en/',
};
ANALYST_GROUPS_CONFIG[ANALYST_GROUPS.FRAUD] = {
  label: 'Signals',
};
ANALYST_GROUPS_CONFIG[ANALYST_GROUPS.REQUIREMENTS] = {
  label: 'Requirements',
};
ANALYST_GROUPS_CONFIG[ANALYST_GROUPS.VERIFICATIONS] = {
  label: 'Document Content Checks',
};

export const ANALYST_VERIFICATIONS_CONFIG = {
  KEY_DETAILS_PRESENT: {
    label: 'Are key details present?',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  IS_ACCEPTABLE_DOCUMENT: {
    key: 'IS_ACCEPTABLE_DOCUMENT',
    label: 'Is Document Acceptable?',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  TRANSACTION_AMOUNTS: {
    label: 'Transactions',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  PERSON_ADDRESS_EXISTENCE: {
    label: 'Person Address',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  COMPANY_EXISTENCE: {
    label: 'Company',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  COMPANY_ADDRESS_EXISTENCE: {
    label: 'Company Address',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  CONNECTION_BETWEEN_COMPANY_AND_ADDRESS: {
    label: 'Company and Address Connection',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  COMPANY_WEB_PRESENCE: {
    label: 'Web Presence',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  CONNECTION_BETWEEN_PERSON_AND_COMPANY: {
    label: 'Person and Company Connection',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  CONNECTION_BETWEEN_PERSON_AND_ADDRESS: {
    label: 'Person and Address Connection',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  LOAN_IDENTIFICATION: {
    label: 'Loan Provider Check',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  UTILITY_PROVIDER_EXISTENCE: {
    label: 'Utility Provider',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  CONNECTION_BETWEEN_UTILITY_PROVIDER_AND_REGION: {
    label: 'Utility Provider Region',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  CONNECTION_BETWEEN_SELLER_AND_ADDRESS: {
    label: 'Seller and Address Connection',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  INVOICE_SELLER_EXISTENCE: {
    label: 'Seller',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
  CONNECTION_BETWEEN_PRODUCTS_AND_SELLER: {
    label: 'Products and Seller Connection',
    icon: 'small-alert-triangle',
    group: ANALYST_GROUPS.RISKS,
  },
};
